import React, { useState } from 'react'
import { Transition } from 'react-transition-group'
import { useResponsiveValue } from '@theme-ui/match-media'

import {
  TimelineStyled,
  TimelineItemStyled,
  TimelineItemContentStyled,
  TimelineItemImageStyled,
  TimelineItemTitleStyled,
  TimelineItemBodyStyled,
  TimelineItemHeadStyled,
  TimelineItemIconStyled
} from './styles'
import { TimelineProps } from './types'
import Image from './../../atoms/Image'
import { IconAccordionArrowAlt } from './../../../assets/svg/index'
import { scrollToSection } from './../../../common/helpers'
import { transitionStyles } from './cfg'

const Timeline: React.FC<TimelineProps> = ({ list }) => {
  const isDesktop = useResponsiveValue([false, true, true, true], {
    defaultIndex: 0
  })

  const [isAccordionActive, setIsAccordionActive] = useState('')

  const handleAccordionClick = (value: string): void => {
    if (!isDesktop) {
      isAccordionActive === value ? setIsAccordionActive('') : setIsAccordionActive(value)
      setTimeout(function () {
        scrollToSection(`${value}-tab`, 600, 100, -200)
      }, 100)
    }
    return
  }

  return (
    <TimelineStyled>
      {list.map(({ key, title, content, image }) => {
        const isAccordionActiveState = isAccordionActive === key
        return (
          <TimelineItemStyled>
            <TimelineItemContentStyled>
              <TimelineItemImageStyled>
                <Image objectFit="contain" fluid={image.childImageSharp} alt={image.alt} />
              </TimelineItemImageStyled>

              <TimelineItemHeadStyled isAccordionActive={isAccordionActiveState} onClick={() => handleAccordionClick(key)}>
                <TimelineItemTitleStyled as="h3" variant="bodyMontserrat26">
                  {title}
                </TimelineItemTitleStyled>
                <TimelineItemIconStyled>
                  <IconAccordionArrowAlt />
                </TimelineItemIconStyled>
              </TimelineItemHeadStyled>
              <Transition in={isAccordionActiveState} timeout={150} appear>
                {(state) => (
                  <TimelineItemBodyStyled
                    name={`${key}-tab`}
                    isAccordionActive={isAccordionActiveState}
                    style={{
                      ...transitionStyles[state]
                    }}
                    dangerouslySetInnerHTML={{
                      __html: content
                    }}
                  />
                )}
              </Transition>
            </TimelineItemContentStyled>
          </TimelineItemStyled>
        )
      })}
    </TimelineStyled>
  )
}

export default Timeline
